import { useMemo } from 'react';
import { traceMapStore } from '../utils/traceMapStore';

export const useTraceMap = () => {
    const traceMap = traceMapStore.getValue();

    return useMemo(
        () => ({
            addTrace: traceMap.addTrace,
            getTraceName: traceMap.getTraceName,
            removeTrace: traceMap.removeTrace,
        }),
        [traceMap]
    );
};
